import { decryptMessage, encryptMessage } from "../Helpers/Crypto";

const CodelessDataEncKey = "F9C3F5E7-A55B-481C-BBC8-08BC74D24FF6";

export function encryptData(data) {
    let cypherText = "";
    const dataToEncrypt = "!" + data + "|" + new Date().toUTCString() + "!";

    cypherText = encryptMessage(dataToEncrypt, CodelessDataEncKey);

    return cypherText;
}

export function decryptData(cypherText) {
    let data = decryptMessage(cypherText, CodelessDataEncKey);

    if (data.startsWith("!") && data.endsWith("!")) {
        data = data.substring(1, data.length - 1);

        const parts = data.split("|");

        if (parts.length === 2) {
            // Get Current UTC date time.           

            const currentDate = new Date(new Date().toUTCString());
            // Get cypher date time.
            let cypherDate = new Date(parts[1]);

            // Add 2 minutes to cypher date time.
            cypherDate = addSecondsToDate(cypherDate, 120);

            // Check if current date is less than or equal to cypher date.
            if (currentDate <= cypherDate) {
                data = parts[0];  // Cypher is valid.
            }
            else {
                throw new Error("Cypher is expired.")
            }
        } else {
            throw new Error("Invalid cypher.")
        }
    } else {
        throw new Error("Invalid cypher.")
    }

    return data;
}

export function addSecondsToDate(myDate, seconds) {
    myDate.setSeconds(myDate.getSeconds() + seconds);
    return myDate;
}